import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AddCustomerModalComponent } from '../add-customer-modal/add-customer-modal.component';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { AddEditCustomerFormComponent } from '../../forms/add-edit-customer-form/add-edit-customer-form.component';

@Component({
  selector: 'app-edit-customer-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    AddEditCustomerFormComponent
  ],
  templateUrl: '../add-customer-modal/add-customer-modal.component.html',
  styleUrl: '../add-customer-modal/add-customer-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditCustomerModalComponent extends AddCustomerModalComponent {

  public override isAdd = false;

  public constructor() {
    super();
    this.namespace = 'customers/edit-customer-modal';
  }
}
